// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridOffset, GridWrapper } from "@turnerBlueprint/MobiusOverrides/GridContainer/GridContainer";
import { productCardStyles } from "@turnerBlueprint/Overrides/Widgets/ProductList/ProductListProductCard";
import { color, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

productCardStyles.gridContainer = {
    css: css`
        display: grid;
        grid-template-columns: 120px minmax(0, 1fr) 268px;
        grid-column-gap: 20px;
        width: 100%;
        padding: 20px 0;
        ${xScreen("lte", "md")} {
            grid-template-columns: 99px minmax(0, 1fr);
            grid-row-gap: 12px;
            &&& {
                height: 100%;
            }
        }
    `,
};

productCardStyles.productListProductImage = {
    wrapper: {
        css: css`
            margin: 0 auto;
        `,
    },
    productImage: {
        img: {
            css: css`
                height: 120px;
                object-fit: contain;
                ${xScreen("lte", "md")} {
                    max-height: 99px;
                }
            `,
        },
    },
};

productCardStyles.leftColumnGridItem = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 1 / 5;
    `,
};

productCardStyles.infoGridItem = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 1 / 5;
        ${xScreen("lte", "md")} {
            &,
            & > ${GridWrapper}, & > ${GridWrapper} > ${GridOffset} {
                height: 100%;
            }
        }
    `,
};
productCardStyles.actionsGridItem = {
    css: css`
        grid-column: 3 / 4;
        grid-row: 1 / 6;
        &&& .bottom-section {
            margin: 0;
        }
        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
            grid-row: 5 / 6;
            margin-top: auto;
        }

        ${({ hasMultipleUom }: any) =>
            hasMultipleUom &&
            css`
                ${xScreen("gte", "lg")} {
                    .qty-section {
                        flex-grow: 1;
                        width: 100%;
                    }
                }
            `}
    `,
};
productCardStyles.searchScoreDataGridItem = {
    css: css`
        grid-column: 1 / 4;
        grid-row: 6 / 7;
        ${xScreen("lte", "md")} {
            grid-column: 2 / 3;
            &:empty {
                display: none;
            }
        }
    `,
};

productCardStyles.productPriceAndActionsStyles = {
    productGridContainer: {
        container: {
            css: css`
                max-width: unset;
                width: 100%;
                & > .top-section {
                    &,
                    & > .info-section {
                        flex-grow: 0;
                    }
                }
            `,
        },
        info: {
            css: css`
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
            `,
        },
        addToCartActions: {
            css: css`
                margin-top: 8px;
                flex-wrap: wrap;
                ${xScreen("lte", "md")} {
                    gap: 12px;
                    margin-top: 0;
                }
            `,
        },
    },
    addToCartActions: {
        css: css`
            display: flex;
            align-items: end;
            gap: 8px;
            flex-wrap: wrap;
            ${xScreen("lte", "md")} {
                gap: 12px;
            }
        `,
    },

    addToCartButton: {
        mergeCss: true,
        css: css`
            flex: 1;
            min-width: 132px;
        `,
    },
    productAvailableStyles: {
        container: {
            css: css`
                ${xScreen("lte", "md")} {
                    width: 100%;
                }
            `,
        },
    },
    productUnitOfMeasureSelectStyles: {
        cssOverrides: {
            formField: css`
                ${xScreen("lt", "sm")} {
                    max-width: 85px;
                }
            `,
        },
    },
};

productCardStyles.productInformationStyles = {
    container: {
        gap: 0,
    },
    descriptionStyles: {
        productDetailLink: {
            css: css`
                min-height: 32px;
                ${xScreen("lte", "md")} {
                    min-height: 48px;
                }
            `,
        },
        productDetailDescription: {
            css: css`
                min-height: 32px;
                ${xScreen("lte", "md")} {
                    min-height: 48px;
                }
            `,
        },
    },
    partNumbersGridItem: {
        width: [12, 12, 12, 6, 6],
    },
    availabilityGridItem: {
        width: [12, 12, 12, 6, 6],
        css: css`
            ${xScreen("lte", "md")} {
                &&& {
                    margin: 8px 0;
                }
            }
        `,
    },
    attributes: {
        container: {
            css: css`
                padding-top: 8px;
                margin-top: 8px;
                border-top: 1px solid ${color("common.border")};
            `,
        },
    },
};
